import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'
import { GygChannels } from '@/src/types/apps/gygChannels'

interface ChannelInitialState {
  channels?: GygChannels[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: ChannelInitialState = {
  channels: null,
  loading: false,
  success: null,
  error: null
}

interface ChannelsResponse {
  data: GygChannels[]
}

export const getChannels = createAsyncThunk<ChannelsResponse, GygQueryOptions, Redux>(
  'gygChannels/getAllChannels',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`channels`, { params: gygQueryOptions })

    return responseData
  }
)

const gygChannelSlice = createSlice({
  name: 'getAllMenuTags',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getChannels.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getChannels.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.channels = action.payload.data
      })
      .addCase(getChannels.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch channels'
      })
  }
})

export default gygChannelSlice.reducer
